<div class="portlet light">
  <div class="portlet-title">
    <div class="caption caption-md">
      <span class="caption-subject text-uppercase">ENVIRONMENTAL SAVINGS</span>
    </div>
  </div>
  <div class="portlet-body text-center" *ngIf="environmentSavingData">
    <div class="globalwarming">
      <img
        class="card-img-top img img-fluid"
        src="assets/images/GlobalWarming.png"
        alt=""
        style="height: 124px; width: 118px"
      />
      <h1>
        <b>{{ environmentSavingData.enviromentalImpact }}t CO<sub>2</sub> -eq</b>
      </h1>
    </div>
  </div>
</div>
